import React, { ReactNode } from "react";
import { ReleaseProvider } from "../simulator/context/release";

import { useWorkspace } from "../simulator/context/wrokspace";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export const SimulatorWrapper = ({
  children,
  simulatorId,
}: {
  children: ReactNode;
  simulatorId?: string;
}) => {
  const { simulatorId: id } = useParams();
  const { workspace } = useWorkspace();
  const { user } = useAuth0();
  return (
    <ReleaseProvider simulatorId={simulatorId}>{children}</ReleaseProvider>
  );
};
